var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMastercardSolid(_ref) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 4h20a2 2 0 012 2v12a2 2 0 01-2 2H2a2 2 0 01-2-2V6a2 2 0 012-2zm9.14 12.73A6.33 6.33 0 019 12a6.23 6.23 0 012.14-4.73 5.3 5.3 0 100 9.46zm.86-8.9a5.31 5.31 0 010 8.34 5.3 5.3 0 010-8.34zm.89 8.9c.74.375 1.56.57 2.39.57v-.03a5.3 5.3 0 10-2.4-10c.294.25.562.528.8.83a6.32 6.32 0 01-.79 8.63z",
    fill: "#121318"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.32 18.4V5.6h19.36v12.8H2.32zm1.917-9.258A5.3 5.3 0 005.45 16.17a5.28 5.28 0 005.69.56A6.33 6.33 0 019 12a6.23 6.23 0 012.12-4.73 5.3 5.3 0 00-6.883 1.87zM12 16.17a5.3 5.3 0 010-8.34 5.31 5.31 0 010 8.34zm.89.56c.74.374 1.56.57 2.39.57v-.03a5.3 5.3 0 10-2.4-10c.294.249.562.527.8.83a6.32 6.32 0 01-.79 8.63z",
    fill: "#121318",
    opacity: 0.01
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.3 15.23l.06-.15h-.06v.05l-.022.047-.038-.096h-.06v.05l.06.13.038-.084.022.053z",
    fill: "#121318"
  })));
}

export default SvgMastercardSolid;